/**
 * UnsavedChangesDialog Component
 *
 * Confirmation dialog shown when user tries to navigate away with unsaved changes.
 * Used by mobile pages to handle back button navigation with dirty state.
 */

import React from 'react';

import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@enfomentis/ui';

export interface UnsavedChangesDialogProps {
  /** Whether the dialog is open */
  isOpen: boolean;
  /** Called when user clicks Cancel (stay on page) */
  onClose: () => void;
  /** Called when user clicks Discard (navigate away) */
  onDiscard: () => void;
}

export const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  isOpen,
  onClose,
  onDiscard,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalContent>
        <ModalHeader>Unsaved Changes</ModalHeader>
        <ModalBody>
          <p className="text-text-secondary">
            You have unsaved changes. Discard them?
          </p>
        </ModalBody>
        <ModalFooter>
          <Button variant="flat" onPress={onClose}>
            Cancel
          </Button>
          <Button color="danger" onPress={onDiscard}>
            Discard
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
